/* Y2K vitrin rayı (Sezon Seçkisi) — CSS scroll-snap üstüne ince kontrol katmanı.
   Autoplay YOK. Ok butonları görünür genişlik kadar sayfalar; dot'lar karta
   götürür; aktif dot kaydırmayla güncellenir. prefers-reduced-motion'da
   kaydırma animasyonsuz (behavior: auto). Ray tabindex=0 — odaktayken ok
   tuşlarıyla doğal kaydırma çalışır.

   Sürükleme katmanı YALNIZ (hover: hover) and (pointer: fine) cihazlarda
   kurulur ve yalnız pointerType 'mouse' olaylarını işler — dokunmatikte
   hiçbir pointer dinleyicisi eklenmez, ray sadece native scroll ile kayar.
   Masaüstünde gerçek bir sürüklemeden sonra ilk click bastırılır ki
   bırakınca istemsiz link/quick-add tetiklenmesin. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const DRAG_CLICK_THRESHOLD = 8; // px — altı tıklama sayılır, üstü sürükleme

  class Y2KRail extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('.y2k-feat__rail');
      if (!this.rail) return;
      this.cards = [...this.rail.children];
      this.prev = this.querySelector('[data-rail-prev]');
      this.next = this.querySelector('[data-rail-next]');
      this.dots = [...this.querySelectorAll('[data-rail-dot]')];

      if (this.prev) this.prev.addEventListener('click', () => this.page(-1));
      if (this.next) this.next.addEventListener('click', () => this.page(1));
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(Number(dot.dataset.railDot)));
      });
      this.rail.addEventListener('scroll', () => this.queueUpdate(), { passive: true });
      window.addEventListener('resize', () => this.queueUpdate(), { passive: true });

      if (finePointer.matches) this.enableMouseDrag();

      this.update();
    }

    enableMouseDrag() {
      const rail = this.rail;
      let dragging = false;
      let startX = 0;
      let startLeft = 0;
      let maxMove = 0;

      // Native öğe sürüklemesi (link/görsel hayaleti) fare için de kapalı
      rail.addEventListener('dragstart', (e) => e.preventDefault());

      rail.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        dragging = true;
        maxMove = 0;
        startX = e.clientX;
        startLeft = rail.scrollLeft;
      });

      window.addEventListener('pointermove', (e) => {
        if (!dragging || e.pointerType !== 'mouse') return;
        const dx = e.clientX - startX;
        const abs = Math.abs(dx);
        if (abs > maxMove) maxMove = abs;
        if (maxMove > DRAG_CLICK_THRESHOLD) rail.classList.add('y2k-rail--drag');
        rail.scrollLeft = startLeft - dx;
      });

      const end = (e) => {
        if (!dragging || (e.pointerType && e.pointerType !== 'mouse')) return;
        dragging = false;
        rail.classList.remove('y2k-rail--drag');
        if (maxMove > DRAG_CLICK_THRESHOLD) this.suppressNextClick();
      };
      window.addEventListener('pointerup', end);
      window.addEventListener('pointercancel', end);
    }

    suppressNextClick() {
      const swallow = (e) => {
        e.preventDefault();
        e.stopPropagation();
      };
      this.rail.addEventListener('click', swallow, { capture: true, once: true });
      // Bırakma click üretmezse (ray dışında pointerup) dinleyici sahipsiz kalmasın
      setTimeout(() => {
        this.rail.removeEventListener('click', swallow, { capture: true });
      }, 150);
    }

    behavior() {
      return reduce.matches ? 'auto' : 'smooth';
    }

    page(dir) {
      this.rail.scrollBy({ left: dir * this.rail.clientWidth * 0.9, behavior: this.behavior() });
    }

    goTo(index) {
      const card = this.cards[index];
      if (!card) return;
      const delta = card.getBoundingClientRect().left - this.rail.getBoundingClientRect().left;
      this.rail.scrollTo({ left: this.rail.scrollLeft + delta, behavior: this.behavior() });
    }

    queueUpdate() {
      if (this.raf) return;
      this.raf = requestAnimationFrame(() => {
        this.raf = null;
        this.update();
      });
    }

    update() {
      const rail = this.rail;
      const maxScroll = rail.scrollWidth - rail.clientWidth - 2;
      if (this.prev) this.prev.disabled = rail.scrollLeft <= 2;
      if (this.next) this.next.disabled = rail.scrollLeft >= maxScroll;

      // Aktif kart: rayın sol kenarına en yakın kart; ray sona dayandıysa sonuncu
      let active = 0;
      if (rail.scrollLeft >= maxScroll) {
        active = this.cards.length - 1;
      } else {
        const railLeft = rail.getBoundingClientRect().left;
        let bestDist = Infinity;
        this.cards.forEach((card, i) => {
          const dist = Math.abs(card.getBoundingClientRect().left - railLeft);
          if (dist < bestDist) {
            bestDist = dist;
            active = i;
          }
        });
      }
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === active)));
    }
  }

  if (!customElements.get('y2k-rail')) customElements.define('y2k-rail', Y2KRail);
})();
